import React, { useEffect, useState, useMemo } from "react";
import iconRs1 from "../../img/icon-rs1.png";
import lockedRs1 from "../../img/icon-locked.png";
import { useSelector } from "react-redux";
import { match, round } from "../../Others/functions";
import { useLocation } from "react-router";
import { useQuery } from "react-query";
import { Offcanvas } from "react-bootstrap";
const url = process.env.React_App_Api_url;

const getProducts = async () => {
  try {
    const response = await fetch(`${url}/ruppeedeal`);
    if (!response.ok) {
      throw new Error("RUPPEE REQUEST RESPONSE FAILED");
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.log("ERROR AT GETTING RUPPEE ONE PRODUCTS", error);
  }
};

const store = "Rashan-4";
const vendorId = "37cfbaa0cdd335e81abd4aba05c5e254";
const INITIAL_VALUE = 800;
const RuppeOne = (props) => {
  const [rsOneBottomSheet, setrsOneBottomSheet] = useState(false);
  const [initialValue, setInitialValue] = useState(INITIAL_VALUE);
  const [dealValue, setDealValue] = useState(0);
  const [rupeeOneBill, setRuppeeOneBill] = useState(null);
  const { state } = useLocation();
  const backdrop = useMemo(
    () => ({
      name: "Eable backdrop",
      scroll: false,
      backdrop: true,
    }),
    []
  );
  const info = useSelector(
    (state) =>
      state.vendor.vendorList?.filter((el) =>
        match(el.info?.storeLink, store)
      )?.[0]?.info
  );
  const cart = useSelector(
    (state) =>
      state.user.cart?.filter((c) => c.vendorId === vendorId)?.[0]?.cart
  );

  const {
    data: ruppeeData,
    isLoading: ruppeeLoading,
    isError: rupeeeError,
  } = useQuery(["RUPPEE_ONE_DATA"], () => getProducts());
  // console.log(ruppeeData);
  useEffect(() => {
    if (cart?.length) {
      const filteredCartForRupperOneDeals = cart.filter((item) =>
        item.subCat === "Atta, Maida & Sooji" ||
        item.subCat === "Oil" ||
        item.subCat === "Ghee & Vanaspati"
          ? false
          : true
      );
      if (!filteredCartForRupperOneDeals?.length) {
        return;
      }
      let temp = filteredCartForRupperOneDeals.reduce((t, product) => {
        let total = t.Total || 0;
        total += product.finalSp * product.qty;

        t = {
          Total: round(total, 2),
        };
        return t;
      }, {});

      if (state && state?.coupon.billAmount <= temp.Total) {
        let coupon = state.coupon;
        let discount;
        if (coupon.discountType === "Flat Discount") {
          discount = coupon.amount;
        } else {
          discount = round((temp?.Total * coupon.percent) / 100, 2);
          if (
            coupon.maxDiscount &&
            parseFloat(discount) > parseFloat(coupon.maxDiscount)
          ) {
            discount = coupon.maxDiscount;
          }
        }
        temp.Total = round(temp.Total - discount, 2);
      }

      setRuppeeOneBill(temp);
    }
  }, [cart, info, state]);

  useEffect(() => {
    if (!rupeeOneBill) {
      return;
    }
    const ratio = rupeeOneBill?.Total / 800;
    let val = Math.trunc(ratio) + 1;
    if (Math.trunc(ratio) <= 7) {
      setDealValue(Math.trunc(ratio));
    }
    setInitialValue(val * 800);
  }, [rupeeOneBill]);

  return rupeeeError || ruppeeLoading ? null : (
    <div className="homeRs1Wrapper">
      <div className="rs1-bottombar" onClick={() => setrsOneBottomSheet(true)}>
        <p>
          Add items worth <strong>₹{initialValue}</strong> to unlock the
          <strong>₹1</strong> deal
        </p>
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${(rupeeOneBill?.Total / initialValue) * 100}%` }}
            aria-valuenow={(rupeeOneBill?.Total / initialValue) * 100}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
      <Offcanvas
        show={rsOneBottomSheet}
        placement="bottom"
        onHide={() => setrsOneBottomSheet(false)}
        className="h-auto bg-tr rs1StoreCanvas"
        {...backdrop}
      >
        <Offcanvas.Header>
          <h3 className="offset-title">Buy at ₹1 Store</h3>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="bg-white d-flex p-16">
            <div className="card-wrap">
              <div className="sec-title">
                <img src={iconRs1} alt="titleImg" width="40" />
                <h4>Unlock ₹1 deals at every ₹800</h4>
              </div>
              {/* Dont pick this entire div Use on rs1-locked div in cards */}
              <div className="rs1-horiz-scroll">
                {ruppeeData.map((item, index) => (
                  <div
                    key={item?.pID + index}
                    className="1rs-store-card horiz-scroll bg-gradient-green"
                  >
                    <h3>₹{INITIAL_VALUE * (index + 1)}</h3>
                    <div className="card">
                      {dealValue > index ? null : (
                        <div className="rs1-locked">
                          <img src={lockedRs1} alt="titleImg" width="32" />
                          <p>Locked</p>
                        </div>
                      )}

                      <div className="card-top-image">
                        <img
                          src={item?.imageURL}
                          loading="lazy"
                          alt="product"
                          width="auto"
                          height="100%"
                        />
                      </div>
                      <div className="card-body">
                        <h3>{`${item?.newProductName}`}</h3>
                        <span className="item-weight">
                          {item?.newProductSize}
                        </span>
                        <h5>
                          <strong>{`₹${item?.sp}`}</strong>
                          {item?.mrp !== item?.sp && (
                            <del>{`₹${item?.mrp}`}</del>
                          )}
                        </h5>
                        {item?.mrp !== item?.sp && (
                          <span className="badge badge-success">{`Save ₹${Math.trunc(
                            item?.mrp - item?.sp
                          )}`}</span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {dealValue > 0 ? (
                <p className="unlocked-text">
                  You have unlocked {dealValue} deal successfully!
                </p>
              ) : null}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default RuppeOne;
